import React from 'react';
import './button.css'
import { useNavigate } from 'react-router';

function C2wButton( { text=null, flag= null, route =null}  ) {
  const navigate = useNavigate()
  return (
    <button onClick={ () => {
      navigate(`${route}`, {state: flag})
    }}  className='ViewAllBtn'>{text}</button>
  )
}

export default C2wButton;
